<template>
    <div v-loading="boxLoading">
        <el-card>
            <el-form :inline="true">
                <el-form-item label="设置名称:">
                    <el-input style="width:300px" placeholder="请输入"></el-input>
                </el-form-item>
                <el-button class="myBtn">查询</el-button>
            </el-form>
            <!-- 设置区域 -->
            <div class="content">
                <div class="left">
                    <div class="item active">全部</div>
                </div>
                <div class="right">
                    <el-table :data="tableData" :border="true" style="margin-top:0">
                        <el-table-column width="120px" label="业务模块" prop="ywmk"></el-table-column>
                        <el-table-column width="200px" label="设置名称" prop="szmc"></el-table-column>
                        <el-table-column label="参数与说明">
                            <template slot-scope="scope">
     <span @click="$router.push('/meituanTakeAwayStoreBind')"  class="setBtn"
      v-if="scope.row.ywmk=='外卖设置' && scope.row.szmc=='美团外卖' && showMT ">
      去设置&gt;</span>
           <span @click="$router.push('/meituanTakeAwayStoreBind')"  class="setBtn"
      v-if="scope.row.ywmk=='外卖设置' && scope.row.szmc=='美团外卖' && !showMT ">
      去设置&gt;</span>
        <span @click="$router.push('/eleTakeAwayStoreBind')"  class="setBtn"
      v-if="scope.row.ywmk=='外卖设置' && scope.row.szmc=='饿了么'">去设置&gt;</span>
             <el-switch
             @change="switchChange(scope.row)"
         v-if="scope.row.ywmk!='外卖设置'"
    v-model="scope.row.status"
    active-color="#ffbd00"
    inactive-color="#ccc"
    :active-value="1"
    :inactive-value="0">
  </el-switch>
  <span style="color:rgb(153,153,153);font-size:14px;margin-left:8px">{{scope.row.text}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                showMT:true,
                boxLoading:true,
                tableData:[
        {ywmk:'短信',szmc:'短信开关',status:1,text:'开启后，可使用短信'},
       {ywmk:'库存',szmc:'库存开关',status:0,text:'开启后，可使用库存'},
    {ywmk:'外卖设置',szmc:'美团外卖',status:1,text:'开启后，外卖订单自动接单打印，外卖菜品一体化管理，报表统一对账'},
    {ywmk:'外卖设置',szmc:'饿了么',status:1,text:'开启后，外卖订单自动接单打印，外卖菜品一体化管理，报表统一对账'},
 {ywmk:'团购设置',szmc:'抖音团购体验券',status:1,text:'开启后，支持收银、点餐助手、手机点餐多场景验券，方便快捷'},
 {ywmk:'手机点餐设置',szmc:'扫码点单',status:1,text:'开启后，支持扫码点餐，节省餐厅人力'},
  {ywmk:'手机点餐设置',szmc:'预点餐',status:1,text:'开启后，支持顾客远程预点餐'},
  {ywmk:'修改订单设置',szmc:'修改订单',status:0,text:'开启后，支持修改订单'}


                ]
            }
        },
        methods:{
          async  getMeiTuan(){
           let res=await this.$http.post('/meituanAppAuthToken/queryOne',{merchantCode:this.merchantCode,businessId:'2'})
          if(res.data.data!=null){
            this.showMT=false
          }else{
            this.showMT=true
          }
          },
           switchChange(row){
          let {szmc,status}=row
           this.setMessage(szmc,status)
           },
           // 短信和库存
     async  setMessage(name,status){
        if(name=='修改订单'){     
     let response= await this.$http.post('merchantBaseInfo/setUpdateOrder',{isUpdateOrderTime:status,merchantCode:localStorage.getItem('merchantCode')})
     console.log(response)
     if(response.data.code!=200){
        this.$message.error(response.data.message)
    }
        }else{
      var data={}
        if(name=='短信开关'){
            data.isSms=status
        }else if(name=='库存开关'){
            data.stockValid=status
        }
        data.merchantCode=localStorage.getItem('merchantCode')
     let res=await this.$http.post('/merchantBaseInfos/updateConfig',data)
    if(res.data.code!=200){
        this.$message.error(res.data.message)
    }
        }

        },
        //获取短信和库存
      async  getMessage(){
      let res=await  this.$http.post('/merchantBaseInfos/queryConfig',{merchantCode:localStorage.getItem('merchantCode')})
      let {isSms,stockValid}=res.data.data   
      this.tableData[0].status=isSms //isSms 短信
      this.tableData[1].status=stockValid  //stockValid  库存
      this.boxLoading=false
      },
      //获取修改订单
      async getSetOrder(){
  let res=await this.$http.post('merchantBaseInfo/queryOne',{merchantCode:localStorage.getItem('merchantCode')})
   this.tableData[7].status=parseInt(res.data.data.isUpdateOrderTime)
   console.log(this.tableData)
   },
        },
        created(){
            this.getMeiTuan()
            this.getMessage()  //短信和库存
            this.getMeiTuan()
            this.getSetOrder()
        }
    }
</script>

<style lang="scss" scoped>
.content{
    display: flex;
    width: 100%;
    height: calc(100vh - 170px);
    .left{
        width: 142px;
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        margin-right: 6px;
        border-right: 1px solid rgb(232, 232, 232);
        .item{
        height: 38px;
        padding: 0px 0px 0px 4px;
         margin: 0px 4px 0px 0px;
         line-height: 38px;
         text-align: left;
         border-radius: 4px;
         font-size: 14px;
        }
        .item.active{
            background-color: rgba(255, 189, 0, 0.2);
        }
    }
    .right{
        width: calc(100% - 152px);
    }
}
.myBtn{
  background:#f59a23;
  color:#fff;
  transform: translateY(2px);
  margin-left:12px;
}
.setBtn{
    color:rgb(255, 96, 0);cursor:pointer;font-size:14px;margin-left:8px
}
</style>